import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow p-4" }
const _hoisted_2 = { class: "flex justify-between items-start" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = {
  key: 0,
  class: "h-10 w-10 rounded-full overflow-hidden mr-3"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center overflow-hidden mr-3"
}
const _hoisted_7 = { class: "text-sm font-semibold text-primary" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = { class: "text-xs text-gray-500 ml-2" }
const _hoisted_11 = {
  key: 0,
  class: "mt-1 text-gray-700"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_13 = { class: "flex justify-end mt-2 space-x-2" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "relative"
}
const _hoisted_16 = {
  key: 0,
  class: "absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10"
}
const _hoisted_17 = { class: "py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userProfile && _ctx.userProfile.avatar_url)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.userProfile.avatar_url,
                alt: "User avatar",
                class: "h-full w-full object-cover"
              }, null, 8, _hoisted_5)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userInitials), 1)
            ])),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userProfile ? _ctx.userProfile.name : _ctx.userName), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedDate), 1)
          ]),
          (!_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.comment.content), 1))
            : _createCommentVNode("", true),
          (_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editContent) = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary resize-none",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, _ctx.editContent]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                    class: "px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args))),
                    class: "px-3 py-1 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors",
                    disabled: _ctx.isLoading
                  }, " Save ", 8, _hoisted_14)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isOwner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
              class: "text-gray-400 hover:text-gray-600"
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" })
              ], -1)
            ])),
            (_ctx.showDropdown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startEdit && _ctx.startEdit(...args))),
                      class: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    }, " Edit "),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                      class: "block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    }, " Delete ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}